import React, {useMemo} from 'react';
import {isMobileDevice} from "../../common/function";
import UPopup from "../../UPopup";
import PropTypes from "prop-types";
import * as Icon from 'ubs-icons';

const UTableActionItem = React.memo((props) => {
    const getIcon = useMemo(() => {
        if (['assign'].includes(props?.type)) {
            return <Icon.MultiUser fill="#007AFF" size={18}/>;
        }
        if (['copy', 'clone'].includes(props?.type)) {
            return <Icon.Copy fill="#007AFF" size={16}/>;
        }
        if (['revoke'].includes(props?.type)) {
            return <Icon.In fill="#007AFF" size={16}/>;
        }
        if (['delete'].includes(props?.type)) {
            return <Icon.Delete fill="#007AFF" size={16}/>;
        }
        if (['edit'].includes(props?.type)) {
            return <Icon.Edit fill="#007AFF" size={16}/>;
        }
    }, [props?.type])
    return (
        <UPopup
            params={{className: "u_tooltip", disabled: isMobileDevice()}}
            desc={<span>{props?.text ? props?.text : props?.type}</span>}
        >
            <span className="u_icon-rollover u_cp" onClick={() => props?.onClick()}>{getIcon}</span>
        </UPopup>
    );
});

UTableActionItem.propTypes = {
    text: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func,
}

UTableActionItem.defaultProps = {
    text: '',
    type: '',
    onClick: () => {

    },
};

export default UTableActionItem;